import * as angular from "angular";
import { FranchiseResource } from "./FranchiseResource";
import { EditionResource } from "./EditionResource";
import { OnlineStatusResource } from "./OnlineStatusResource";

export let playServiceDrupal = angular.module("play.service.api.drupal", ["ngResource"]);

playServiceDrupal.factory("FranchiseResource", FranchiseResource);
playServiceDrupal.factory("EditionResource", EditionResource);
playServiceDrupal.service("OnlineStatusResource", OnlineStatusResource);

export * from "./FranchiseResource";
export * from "./EditionResource";
export * from "./OnlineStatusResource";
